namespace Introspection {
	// see http://stackoverflow.com/questions/332422/how-do-i-get-the-name-of-an-objects-type-in-javascript

	//const funcNameRegex:RegExp = /function ([^\( ]+?)\(/;
	const funcNameRegex: RegExp = /function ([^\s\.]*?) ?\(/;
	const classNameRegex: RegExp = /class ([^\s\.]*?)\s+/;
	const objNameRegex: RegExp = /\[object (.+)\]/;

	export function getClassName(obj: any): string {
		let results: Array<string>;
		if (obj === undefined) {
			return typeof undefined;
		} else if (obj === null) {
			return "null" // bug in ECMAScript standart
		} else if (obj instanceof Function) {
			let stringRepresentation: string = obj["toString"]();
			if (stringRepresentation.indexOf('class ') === 0) {
				results = classNameRegex.exec(stringRepresentation);
			} else {
				results = funcNameRegex.exec(stringRepresentation);
			}
		} else {
			let stringRepresentation: string = obj["constructor"]["toString"]();
			if (stringRepresentation.indexOf('class ') === 0) {
				results = classNameRegex.exec(stringRepresentation);
			} else {
				results = funcNameRegex.exec(stringRepresentation);
			}
		}
		let result: string = "unknown";
		if (results && results.length > 1) {
			result = results[1];
			if (result.length == 0) {
				return 'Function'
			}
		} else { // IE 11 case for builtInClasses like HTMLDivElement
			let stringified: string = Object.prototype.toString.call(obj);
			results = objNameRegex.exec(stringified);
			if (results && results.length > 1) {
				result = results[1];
			}
		}
		return result;
	}

	export function getPropNames(obj: any): Array<string> {
		let proto:any = obj;

		// нас не интересуют методы которые сами по себе есть на прототипе любого объекта
		// если интересуют то использовать let namesHash = Object.create(null)
		let namesHash:any = {};

		while (proto) {
			let props = Object.getOwnPropertyNames(proto);
			for (let propName of props) {
				if (typeof namesHash[propName] === 'undefined') {
					namesHash[propName] = true;
				}
			}
			proto = getObjectProto(proto);
		}

		let result = new Array<string>();
		for (let propName in namesHash) {
			result.push(propName);
		}
		return result;
	}

	export function getFunctionName(f: Function): string {
		let results: Array<string> = funcNameRegex.exec(f["toString"]());
		let result: string = '';
		if (results && results.length > 1) {
			result = results[1]; // may be empty string;
		}
		if (result === '') {
			return 'unknownFunctionName';
		}
		return result;
	}

	export function getObjectProto(obj: any): any {
		if (isPrimitive(obj)) {
			return null;
		}
		let proto: any = obj['__proto__'];
		if (!proto && Object.getPrototypeOf) {
			proto = Object.getPrototypeOf(obj);
			if (proto === obj) {
				proto = null;
			}
		}
		if (!proto) {
			if (typeof obj.constructor == 'undefined') {
				return null;
			}
			proto = obj.constructor.prototype;
			if (proto === obj) {
				proto = null;
			}
		}
		return proto;
	}

	export function isPrimitive(obj: any): boolean {
		let type: string = typeof obj;
		return obj === undefined || obj === null || type === "number" || type === "string" || type === "boolean";
	}

	export function isString(obj: any): obj is string {
		return typeof obj === 'string';
	}
	
	export function isArray<T>(obj: any): boolean {
		return Object.prototype.toString.call(obj) === '[object Array]';
	}
	
	export function isInt(value:any):boolean {
		return value === (value|0);
	}
	
	export function isUint(value:any):boolean {
		return value === (value>>>0);
	}
	
	export function isNumber(value:any):boolean {
		return typeof value === 'number';
	}
	
	export function isBoolean(value:any):boolean {
		return typeof value === 'boolean';
	}
	
	export function makeChainUnEnumerable(obj:any):void { // 2f65eedb-523a-4a43-b90d-5f17e94c50b5
		if (!Object.getOwnPropertyNames) {
			return;
		}
		let proto = obj;
		while(proto) {
			if (proto === Array.prototype || proto === Object.prototype) {
				return;
			}
			let keys = Object.getOwnPropertyNames(proto);
			for (var i = 0, l = keys.length; i < l; ++i) {
				let key = keys[i];
				let desc = Object.getOwnPropertyDescriptor(proto, key);
				if (desc.enumerable) {
					desc.enumerable = false;
					Object.defineProperty(proto, key, desc);
				}
			}
			proto = proto.__proto__;
		}
	}
}
